import { useTranslation } from "react-i18next";
import { ContactDetailsSectionBreadcrumbs } from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName, useAuth, useEnduserTimelineItems } from "@tellescope/tanstack-query";
import { TimelineSettingsRow } from "../../../ContactsDialog/sections/TimelineSection/TimelineSettingsRow";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export interface TimelineSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const TimelineSection = ({ enduser }: TimelineSectionProps) => {
  const { t } = useTranslation("contacts");
  const { selectedOrganization } = useAuth();
  const { i18n } = useTranslation();
  const { summaryData } = useEnduserTimelineItems({
    enduserId: enduser.id,
    locale: i18n.language,
    onOutOfCredits: () => {
      toast.error(t("You have run out of AI credits. Please purchase more to generate a summary for this timeline."));
    },
  });

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <div className="flex justify-between items-center">
        <ContactDetailsSectionBreadcrumbs
          enduserId={enduser.id}
          breadcrumbs={[{ title: t("Timeline") }]}
          actionButtons={
            summaryData.summary || !selectedOrganization?.bedrockAIAllowed
              ? undefined
              : [
                  {
                    hoverLabel: summaryData.isOutOfCredits
                      ? t("Cannot Generate AI Summary (out of credits)")
                      : summaryData.isGenerating
                      ? t("Generating...")
                      : t("Generate AI Summary"),
                    icon: Sparkles,
                    onClick: summaryData.generateSummary,
                    disabled: !summaryData.canGenerateNewSummary || summaryData.isLoading || summaryData.isGenerating,
                  },
                ]
          }
        />
        <TimelineSettingsRow />
      </div>
      <ContactDetailsSections.TimelineSection
        contact={enduser}
        summary={summaryData.summary}
        summaryIsGenerating={summaryData.isGenerating}
      />
    </div>
  );
};
